// extracted by mini-css-extract-plugin
export default {"container":"DeviceAnonymousLayout_container__90mEf"};